import React, { useEffect, useState, useRef, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "react-bootstrap-icons";
import { FilterContext } from "contextos/FilterContext";

export default function SearchField(props) {
  const [search] = useSearchParams();
  const [laoding, setLoading] = useState(true);
  const [val, setVal] = useState("");
  const [options, setOptions] = useState({ visible: false, checked: false });
  // handle outside ckick
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  const { setUrlParams, handleSubmit } = useContext(FilterContext);
  const timerId = useRef(null);

  useEffect(() => {
    var urlValue = search.get("fulltext");
    if (urlValue) {
      setVal(urlValue);
    } else {
      urlValue = search.get("keywords");
      if (urlValue) {
        setVal(urlValue);
      }
    }
    urlValue = search.get("verbatim");
    if (urlValue === "1") {
      setOptions({ visible: false, checked: true });
      setUrlParams((prev) => ({ ...prev, verbatim: true }));
    }
    setLoading(false);
  }, [search, setUrlParams]);

  const handleInputFocus = () => {
    setOptions({ ...options, visible: true });
  };

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOptions((prev) => ({ ...prev, visible: false, }));
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleSendForm)
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("keydown", handleSendForm);
      };
    }, [ref]);
  }

  function handleSendForm(event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      clearTimeout(timerId.current);
      timerId.current = null;
      setOptions((prev) => ({ ...prev, visible: false, }));
    }
  }

  const timerHandler = () => {
    clearTimeout(timerId.current);
    timerId.current = null;
    setOptions((prev) => ({ ...prev, visible: false, }));
    handleSubmit();
  };

  const handleSubmitF = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOptions((prev) => ({ ...prev, visible: false, }));
    handleSubmit();
  }
  const onInputChange = () => {
    if (timerId.current) {
      clearTimeout(timerId.current);
    }
    timerId.current = window.setTimeout(timerHandler, 3000);
  };

  return (
    <form
      action={``}
      onSubmit={handleSubmitF}
      name='searchForm'
      id='btnFulltext'
    >
      <div className="c-input-search" ref={wrapperRef}>
        {!laoding && (
          <>
            <div className="input-group">
              <input
                type="text"
                className={`form-control`}
                placeholder="Search..."
                aria-label="Search"
                aria-describedby="basic-addon2"
                id="searchValue"
                name="fulltext"
                autoComplete="off"
                value={val}
                onFocus={handleInputFocus}
                onChange={(e) => {
                  setVal(e.target.value);
                  onInputChange();
                }}
              />
              <button className="input-group-text">
                <Search />
              </button>
            </div>
            {/* {options.visible && (
            <div className={`card options_box`}>
              <div className="card-body d-inline-grid opti">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={options.checked ? "1" : ""}
                    name="verbatim"
                    onChange={() => {
                      setOptions((prevState) => ({
                        ...options,
                        checked: !prevState.checked,
                      }));
                      setUrlParams((prev) => ({
                        ...prev,
                        verbatim: !prev.verbatim,
                      }));
                    }}
                    checked={options.checked}
                    id="verbatim"
                  />
                  <label className="form-check-label" htmlFor="verbati">
                    Buscar por términos exactos
                  </label>
                </div>
              </div>
            </div>
          )} */}
          </>
        )}
      </div>
    </form>
  );
}
